export default __webpack_public_path__ + "static/media/silver.759b95f3.png";